import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import 'whatwg-fetch';
import vueCustomElement from 'vue-custom-element'
import VueAnnouncer from '@vue-a11y/announcer'
import VueSessionStorage  from "vue-sessionstorage";
import VueCookie from "vue-cookie";
import "./vee-validate";

Vue.config.productionTip = false;


Vue.use(vueCustomElement);
Vue.use(VueAnnouncer);
Vue.use(VueSessionStorage);
Vue.use(VueCookie);


App.store = store
App.router = router
Vue.customElement('first-five', App)